import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';
import {ApiService} from "../api.service";
import {ActivatedRoute, Router} from "@angular/router";

declare var jquery:any;
declare var $ :any;

@Component({
    selector: 'app-case-practice-report-small',
    templateUrl: './case-practice-report-small.component.html',
    styleUrls: ['./case-practice-report-small.component.css']
})
export class CasePracticeReportSmallComponent implements OnInit ,AfterViewInit{
    @Input() report: any;
    @Input() currentIndex: number;
    @Output() onStartNextCase = new EventEmitter<any>();
    @Output() onSwitchReport = new EventEmitter<any>();
    @Output() onExit = new EventEmitter<any>();

    scrollTop:number;
    sentence:string;
    expert_title: string;
    expert_content: string;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private  apiService: ApiService) { }

    ngOnInit() {
        this.sentence = "不深入了解病因的辅导，犹如隔靴搔痒";
        this.expert_title = "（DDI全球副总裁）";
        this.expert_content ="不深入了解病因的辅导，犹如隔靴搔痒";
    }

    ngAfterViewInit(){
        let html=document.documentElement;
        let htmlFontSize=html.clientWidth/7.5;
        html.style.fontSize=htmlFontSize+"px";
        html.style.backgroundColor="#3d3d6e";

        let smallReportAnswer = document.getElementById("smallReportAnswer");
        let closeBtnReport = document.getElementById("closeBtnReport");


        let bodyHeight = document.body.offsetHeight;
        smallReportAnswer.style.height = bodyHeight*0.8 + 'px';
        smallReportAnswer.style.marginTop = bodyHeight*0.06 + 'px';
        closeBtnReport.style.top = bodyHeight*1.88 + 'px';
        this.enableRolling();
    }

    onDetailBtnClick(){
        let smallReportAnswer = document.getElementById("smallReportAnswer");
        let closeBtnReport = document.getElementById("closeBtnReport");
        let bodyHeight = document.body.offsetHeight;
        this.scrollTop = document.body.scrollTop | document.documentElement.scrollTop;
        $("#shade").fadeIn(500);
        smallReportAnswer.style.top = "0rem";
        closeBtnReport.style.top = bodyHeight*0.88 + 'px';
        this.disableRolling();
        $("#wrap").addClass("fixed");
        $("#wrap").css({top:-this.scrollTop});
    }

    onCloseBtnReportClick(){
        let smallReportAnswer = document.getElementById("smallReportAnswer");
        let closeBtnReport = document.getElementById("closeBtnReport");
        $("#shade").fadeOut(500);
        smallReportAnswer.style.top = "15.34rem";
        closeBtnReport.style.top="25.76rem";
        this.enableRolling();
        $("#wrap").removeClass("fixed");
        document.documentElement.scrollTop = this.scrollTop;
    }

    redo() {
        this.apiService.resetQuiz(this.report.reports[this.currentIndex].id).subscribe(result => {
            var practiceId = result.practiceId;
            var learningPathId = result.learningPathId;
            var practiceMetaId = result.practiceMetaId;

            var link = [];
            if (learningPathId > 0) {
                link = ['case-practice', learningPathId, practiceId];
            }
            else {
                link = [practiceMetaId, 'case-practice'];
            }

            this.router.navigate(link);
        });
    }

    startNextCase() {
        this.onStartNextCase.emit(true);
    }

    close() {
        this.onExit.emit(true);
    }

    switchReport(params) {
        this.onSwitchReport.emit(params);
    }

    moveOut(){
        $('#reportWrap').animate({left:'1000px'}, 500);
    }

    moveIn(){
        $('#reportWrap').animate({left:'0px'}, 500);
    }

    disableRolling(){
        document.getElementById("shade").ontouchstart = function(e){
            e.preventDefault();
        }

        document.getElementById("closeBtnReport").ontouchmove = function(e){
            e.preventDefault();
        }
    }

    enableRolling(){
        $("body").off("touchmove");
    }
}


// WEBPACK FOOTER //
// ./src/app/case-practice-report-small/case-practice-report-small.component.ts